import type { Priority } from "@handoverpro/shared";

// Display metadata for the three clinical priorities, keyed by the wire value.
// The patient list renders one section per priority (High → Medium → Low) and a
// matching pill on each card; both pull their label and colour from here so the
// two can't drift. Colours are the `priority-*` Tailwind tokens (HAN-47).
interface PriorityMeta {
  /** Section heading + pill text. */
  label: string;
  /** Section heading colour (the priority colour). */
  headerClass: string;
  /** Pill background — the same priority colour, with white text. */
  pillClass: string;
}

export const PRIORITY_META: Record<Priority, PriorityMeta> = {
  high: {
    label: "High",
    headerClass: "text-priority-high",
    pillClass: "bg-priority-high text-white",
  },
  medium: {
    label: "Medium",
    headerClass: "text-priority-medium",
    pillClass: "bg-priority-medium text-white",
  },
  low: {
    label: "Low",
    headerClass: "text-priority-low",
    pillClass: "bg-priority-low text-white",
  },
};

// The order sections are rendered in: most urgent first.
export const PRIORITY_ORDER: readonly Priority[] = ["high", "medium", "low"];
